<!--
 * @Author: cmchiu
 * @Date: 2023-03-21 16:10:27
 * @LastEditTime: 2023-05-17 11:29:27
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\layout\AppHeader\appHeader.vue
 * 
-->
<template>
    <div class="app-header">
        <header class="navbar w-100 d-flex align-items-center justify-content-between">
            <a href="./" style="z-index: 100">
                <div class="navbar__logo">
                    <img src="images/logo-mobile.svg" alt="" width="27" height="32" />
                    <img src="images/logo.svg" alt="" width="146" height="58" />
                    <img src="images/logo2.svg" alt="" width="201" height="49" />
                </div>
            </a>

            <!-- Navbar -->
            <navbar />
        </header>
    </div>
</template>

<script>
// import XEUtils from 'xe-utils'
import navbar from './components/Navbar'

export default {
    name: 'appHeader',

    components: { navbar },

    data() {
        return {}
    },

    created() {},

    methods: {},
}
</script>
